import React, { useEffect, useState } from 'react';
import { useParams, Link as RouterLink } from 'react-router-dom';

import { Box, Center, Text, Button, Spinner } from '@chakra-ui/react';
import { useDispatch, useSelector } from 'react-redux';

import OrderHeader from './components/OrderHeader';
import TabNavigation from './components/TabNavigation';
import OverviewTab from './components/OverviewTab';
import LineItemsTab from './components/LineItemsTab';
import BuyerShippingTab from './components/BuyerShippingTab';
import PaymentTab from './components/PaymentTab';
import FulfillmentTab from './components/FulfillmentTab';

import { useTimezone } from 'contexts/TimezoneContext';
import { getOrderByIdApi } from 'features/orders/orders.api';

const Order = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const { timezone } = useTimezone();
  const [activeTab, setActiveTab] = useState('overview');

  const { currentOrder: order, getOrderByIdStatus } = useSelector((s) => s.orders);

  useEffect(() => {
    if (id) {
      dispatch(getOrderByIdApi(id));
    }
  }, [dispatch, id]);

  const tabs = [
    { id: 'overview', label: 'Overview' },
    { id: 'lineItems', label: 'Line items' },
    { id: 'buyerShipping', label: 'Buyer & shipping' },
    { id: 'payment', label: 'Payment & totals' },
    { id: 'fulfillment', label: 'Fulfillment' },
  ];

  if (getOrderByIdStatus === 'pending') {
    return (
      <Center minH="50vh">
        <Spinner size="lg" />
      </Center>
    );
  }

  if (!order) {
    return (
      <Center minH="50vh" flexDirection="column" gap={4}>
        <Text color="red.500" fontSize="lg">
          Order not found
        </Text>
        <Button as={RouterLink} to="/admin/orders" colorScheme="blue" variant="outline">
          Back to orders
        </Button>
      </Center>
    );
  }

  return (
    <Box key={timezone} px={{ base: 4, md: 10 }} py={{ base: 6, md: 8 }} mt="50px">
      <OrderHeader order={order} />
      <TabNavigation activeTab={activeTab} setActiveTab={setActiveTab} tabs={tabs} />

      {activeTab === 'overview' && <OverviewTab order={order} />}
      {activeTab === 'lineItems' && <LineItemsTab order={order} />}
      {activeTab === 'buyerShipping' && <BuyerShippingTab order={order} />}
      {activeTab === 'payment' && <PaymentTab order={order} />}
      {activeTab === 'fulfillment' && <FulfillmentTab order={order} />}
    </Box>
  );
};

export default Order;
